import {BaseApi} from "../BaseApi";

export class ActionApi extends BaseApi {
    public getActionDetails(id?: number): Promise<any> {
        return this.get("/action/:id", {params: {id: id}})
    }
}